import axios from "../../axios";
import React, { Component } from "react";
import DatePicker from "react-multi-date-picker";
import Select from "react-select";
import { SELECT_FREQUENCY_OPTIONS } from "../../utils/constants";
import * as url from "../../utils/url";
import moment from "moment";
import { Col, Row } from "reactstrap";
import MetricsCountCard from "../../components/CountCard/MetricsCountCard";
import MetricsPieChart from "../../components/CountCard/MetricsPieChart";

export default class ProfileMetrics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      frequencyType: 4,
      planning: null,
      cultureApp: null,
      groups: null,
      events: null,
      previosMonthDataAvailable: false,
      startDate: null,
      endDate: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.getMetricsData();
  }

  handleFrequencyTypeChange = (e) => {
    this.setState({ frequencyType: e.value }, () => {
      this.getMetricsData();
    });
  };

  getMetricsData = () => {
    let payload = {};

    this.setState({ loading: true });

    axios
      .get(url.getUserMetricsActionsCount, payload)

      .then(({ data }) => {
        const metrics = data.data;
        this.setState({ loading: false });
        if (metrics != null) {
          this.setState({
            planning: metrics.planning,
            cultureApp: metrics.cultureApp,
            groups: metrics.groups,
            events: metrics.events,
            previosMonthDataAvailable: metrics.previosMonthDataAvailable,
            startDate: metrics.monthStartDate,
            endDate: metrics.monthEndDate,
          });
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.log(err);
      });
  };

  validateEnableModule = (isModule) => {
    const { selectModule } = this.props.user.profile.organizationId;
    let enabled = false;
    if (selectModule) {
      if (isModule && isModule.status) {
        if (isModule.isDisplayed || !isModule.hasOwnProperty("isDisplayed")) {
          enabled = true;
        }
      }
    } else {
      if (
        isModule &&
        (isModule.isDisplayed || !isModule.hasOwnProperty("isDisplayed"))
      ) {
        enabled = true;
      }
    }

    return enabled;
  };

  render() {
    const {
      frequencyType,
      planning,
      cultureApp,
      groups,
      events,
      previosMonthDataAvailable,
      startDate,
      endDate,
      loading,
    } = this.state;

    const org = this.props.user.profile.organizationId;
    return (
      <div className={`mt-1`}>
        <div className="user-profile-metrics-heading">
          {/* 
          <div
          className="my-4"
            style={{
              width: "60%",
              display: "flex",
              gap: "20px",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Select
              value={frequencyType}
              onChange={this.handleFrequencyTypeChange}
              placeholder={"Select frequency type"}
              options={SELECT_FREQUENCY_OPTIONS}
            />
          </div> */}
        </div>

        {
         startDate && endDate ? <div className="p-2 my-2 profile-metrics-for-date-container"><h5>Metrics for {moment(endDate).format("MMMM YYYY")}</h5></div> :""
        }

       
        <div className={``}>
          <div
            className="mb-3"
            style={{
              display: this.validateEnableModule(org["isPlanning"])
                ? "block"
                : "none",
            }}
          >
            <div
              style={{
                backgroundColor: "#0072B2",
                color: "white",
                borderRadius: "0.25rem"
              }}
            >
              <h5 className="py-2 ml-3 font-module-title">Planning</h5>
            </div>

            {planning ? (
              <Row>
                <Col sm={4}>
                  <MetricsCountCard
                    count={planning.total}
                    text={"My Total Actions"}
                    alignTitleCenter
                    previosMonthDataAvailable={previosMonthDataAvailable}
                    // subCountExists
                    // subCount1={{ ...planning.private, text: "Private" }}
                    // subCount2={{ ...planning.enterprise, text: "Enterprise" }}
                  />
                </Col>

                {/* <Col sm={4}>
                  <MetricsPieChart 
                  planning={planning}
                  />
                </Col> */}
                {/* <Col sm={4}>
                  <MetricsCountCard
                    count={planning.public}
                    text={"My Public Tasks"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col> */}
                {/* <Col sm={4}>
                  <MetricsCountCard
                    count={planning.private}
                    text={"My Private Tasks"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col> */}
                {/* <Col sm={4}>
                  <MetricsCountCard
                    count={planning.assigned}
                    text={"Tasks Assigned To you"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col> */}

                {/* <Col sm={4}>
                  <MetricsCountCard
                    count={planning.inprogress}
                    text={"My In-Progress Tasks"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col> */}
                <Col sm={4}>
                  <MetricsCountCard
                    count={planning.completed}
                    text={"My Completed Actions"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                    showPercentData
                  />
                </Col>
                {/* <Col sm={4}>
                  <MetricsCountCard
                    count={planning.incomplete}
                    text={"My Incomplete Actions"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                    showPercentData
                  />
                </Col> */}
                <Col sm={4}>
                  <MetricsCountCard
                    count={planning.overdue}
                    text={"My Overdue Actions"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                    showPercentData
                    // showTotals
                  />
                </Col>
                {/* <Col sm={4}>
                  <MetricsCountCard
                    count={planning.avgProgress}
                    text={"My Completion average"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col> */}
              </Row>
            ) : (
              <div className="my-5 text-center">
                {loading ? "Loading metrics for planning..." : "No metrics found for last month"}
              </div>
            )}
          </div>

          <div
            className="mb-3"
            style={{
              display: this.validateEnableModule(org["isCultureApp"])
                ? "block"
                : "none",
            }}
          >
            <div
              style={{
                backgroundColor: "#009E73",
                color: "white",
                borderRadius: "0.25rem"
              }}
            >
              <h5 className="py-2 ml-3 font-module-title">Culture App</h5>
            </div>
            {cultureApp ? (
              <Row>
                <Col sm={4} className="my_post_card-vertical_center">
                  <MetricsCountCard
                    count={cultureApp.posts}
                    text={"My Posts"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                    alignTitleCenter
                  />
                </Col>
                <Col sm={4}>
                  <MetricsCountCard
                    count={cultureApp.comments_on_posts}
                    text={"Comments on my Posts"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col>
                <Col sm={4}>
                  <MetricsCountCard
                    count={cultureApp.reactions_on_my_posts}
                    text={"Reactions to my Posts"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col>
                {/* <Col sm={8}>
                <Row>
                  <Col sm={6}>
                    <MetricsCountCard
                      count={cultureApp.comments}
                      text={"My Comments"}
                      previosMonthDataAvailable={previosMonthDataAvailable}
                    />
                  </Col>

                  
           
                    <MetricsCountCard
                    count={cultureApp.shared}
                    text={"My Shared Posts"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
           
                  <Col sm={6}>
                    <MetricsCountCard
                      count={cultureApp.reactions}
                      text={"My Reactions"}
                      previosMonthDataAvailable={previosMonthDataAvailable}
                    />
                  </Col>
                
                </Row>
                </Col> */}
              </Row>
            ) : (
              <div className="my-5 text-center">
                {loading ? "Loading metrics for culture app..." : "No metrics found for last month"}
              </div>
            )}
          </div>
          <div
            className="mb-3"
            style={{
              display: this.validateEnableModule(org["isToolkit"])
                ? "block"
                : "none",
            }}
          >
            <div
              style={{
                backgroundColor: "#D55E00",
                color: "white",
                borderRadius: "0.25rem"
              }}
            >
              <h5 className="py-2 ml-3 font-module-title">Events</h5>
            </div>
            {events ? (
              <Row>
                <Col sm={4}>
                  <MetricsCountCard
                    count={events.interested}
                    text={"Events I am Interested in"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col>

                <Col sm={4}>
                  <MetricsCountCard
                    count={events.going}
                    text={"Events I am Going to"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col>
              </Row>
            ) : (
              <div className="my-5 text-center">
                {loading ? "Loading metrics for events..." : "No metrics found for last month"}
              </div>
            )}
          </div>

          {/* <div className="mb-3">
            <h4>Groups</h4>

            {groups > 0 ? (
              <Row>
                <Col sm={4}>
                  <MetricsCountCard
                    count={groups || 0}
                    text={"Groups You Belong To"}
                    previosMonthDataAvailable={previosMonthDataAvailable}
                  />
                </Col>
              </Row>
            ) : (
              <div className="my-5 text-center">
                {" "}
                No metrics found for last month
              </div>
            )}
          </div> */}
        </div>
      </div>
    );
  }
}
